import React from 'react';
import AnimatedSection from '../ui/AnimatedSection';

interface AuthorityBurstProps {
    stats: { label: string; value: string }[];
}

const AuthorityBurst: React.FC<AuthorityBurstProps> = ({ stats }) => {
    return (
        <div className="py-20 bg-white/5">
            <AnimatedSection>
                <div className="mx-auto max-w-7xl px-6">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                        {stats.map((stat, index) => (
                            <div key={index}>
                                <div className="text-4xl md:text-5xl font-bold gold-gradient-text">{stat.value}</div>
                                <div className="mt-2 text-sm text-white/80 tracking-wider uppercase">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </AnimatedSection>
        </div>
    );
};

export default AuthorityBurst;